import axios from "axios";
import { backUrl } from "../utils/backURL";
const API_URL = backUrl;


export const sendGenericEmail = async (emailData) => {
  try {
    const url = `${API_URL}/email/sendEmail`;
    console.log("Sending Email Data:", emailData);

    // Asegúrate de que emailData contenga toEmails, subject, message, y attachments (puede ser [])
    const response = await axios.post(url, {
      toEmails: emailData.toEmails,
      subject: emailData.subject,
      message: emailData.message,
      attachments: emailData.attachments || [], // Enviar array vacío si no hay adjuntos
    });

    console.log("Email send response:", response.data);
    return response.data; // Devuelve la respuesta del backend

  } catch (error) {
    console.error(
      "Error sending generic email:",
      error.response?.data || error.message
    );
    // Re-lanzar el error para que pueda ser capturado en el componente
    throw error;
  }
}; 